<template>
  <v-col md="6" sm="12" class="border-right">
    <v-row>
      <v-col md="6" sm="12">
        <h2 class="text-xl">Emails</h2>
      </v-col>
      <v-col md="6" sm="12">
        <date-period
            :dense="true"
            :dateDiff="5"
            :dateType="dateToggle"
            @periodChange="dateChange"
        ></date-period>
      </v-col>
    </v-row>
    <div style="max-height: 400px; overflow-y: auto;">
      <v-simple-table class="table table-bordered table-responsive">
        <thead>
        <tr>
          <th class="text-center">Date</th>
          <th class="text-center">Total</th>
          <th class="text-center">Sent</th>
          <th class="text-center">Failed</th>
          <th class="text-center">Blocked</th>
          <th class="text-center">Bounced</th>
        </tr>
        </thead>
        <tbody>
        <!-- Show loader when loading -->
        <tr v-if="loading" class="text-center">
          <td colspan="6">
            <v-progress-circular
                indeterminate
                color="primary"
                size="40"
            ></v-progress-circular>
          </td>
        </tr>
        <!-- Show data when not loading -->
        <tr v-else-if="messages.length > 0" v-for="(message,index) in messages" class="text-center" :key="index">
          <td>{{ message.sent_date | dateformat }}</td>
          <td>{{ message.total_count }}</td>
          <td>{{ message.sent_count }}</td>
          <td>{{ message.failed_count }}</td>
          <td>{{ message.blocked_count }}</td>
          <td>{{ message.bounced_count }}</td>
        </tr>
        <tr v-else>
          <td colspan="6" class="text-center">
            <span>No records found</span>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-col>
</template>
<script>
import moment from "moment/moment";

export default {
  data() {
    return {
      date1: moment().subtract(5, "days").format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      dateToggle: "DATE",
      loading: false, // Loader state
      messages:[
        {
          total_count:0,
          sent_count:0,
          failed_count:0,
          blocked_count:0,
          bounced_count:0,
          sent_date:'-',
        }
      ],
    }
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    this.stopAutoFetch();
  },
  methods: {
    startAutoFetch() {
      if(!this.fetchInterval){
        this.fetchInterval = setInterval(() => {
          this.getData(); // Fetch every 3 seconds
        }, 40000); // 3000ms = 3 seconds
      }
    },
    stopAutoFetch() {
      if (this.fetchInterval) {
        clearInterval(this.fetchInterval); // Clears the interval
        this.fetchInterval = null; // Reset the interval ID
      }
    },
    dateChange(data) {
      this.date1 = data.date1;
      this.date2 = data.date2;
      this.getData();
    },
    getData() {
      this.loading = true; // Start loader
      let url = `?mode=${this.dateToggle}&from_date=${this.date1}&to_date=${this.date2}`;

      this.$http
          .get(`monitoring/email-status${url}`)
          .then((response) => {
            if (response.status == 200) {
              this.messages = response.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.loading = false; // Stop loader
            this.startAutoFetch()
          });
    },
  }
}
</script>

<style scoped>

</style>